<template>
    <div
        v-if="isAuthenticated"
        class="mx-2 d-flex align-items-center">
        <el-popover
            placement="bottom"
            trigger="hover">
            <template #reference>
                <font-awesome-layers
                    fixed-width
                    :class="small ? 'fa-lg' : 'fa-2x'">
                    <font-awesome-icon icon="user-circle" />
                    <font-awesome-icon
                        icon="circle"
                        class="text-white"
                        transform="shrink-8 down-4 right-6" />
                    <font-awesome-icon
                        icon="check-circle"
                        class="text-success"
                        transform="shrink-8 down-4 right-6" />
                </font-awesome-layers>
            </template>
            <div>
                Angemeldet als
                <h5 class="font-weight-bold mb-0">
                    {{ userData ? userData.name : 'Mitarbeiter' }}
                </h5>
            </div>
        </el-popover>
    </div>
</template>

<script>

import bookingStartMixin from '@/mixins/bookingStartMixin'

export default {
    name: "EmployeeHint",
    mixins: [bookingStartMixin],
    props: {
        small: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            startVal: 0
        }
    }
}
</script>

<style scoped>
</style>
